<template>
    <div>
        <div class="main-wrapper">
            <layout-header></layout-header>
            <layout-navbar></layout-navbar>
           	<!-- Page Wrapper -->
               <div class="page-wrapper">

				<!-- Page Content -->
                <div class="content container-fluid">

                	<div class="crms-title row bg-white">
                		<div class="col  p-0">
                			<h3 class="page-title m-0">
			                <span class="page-title-icon bg-gradient-primary text-white mr-2">
			                  <i class="feather-bar-chart-2"></i>
			                </span> {{ $t('menu.overview') }} </h3>
                		</div>
                		<div class="col p-0 text-right">
                			<ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
								<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
								<li class="breadcrumb-item active">{{ $t('menu.overview') }}</li>
							</ul>
                		</div>
                	</div>

					<!-- Page Header -->
					<div class="page-header pt-3 mb-0 ">
						<div class="row">
							<div class="col">
								<h4 class="advanced-report">{{ $t('client_overview') }}</h4>
							</div>
						</div>

					</div>
					<!-- /Page Header -->

					<!-- Content Starts -->
					<div class="row m-0">
						<div class="col-md-12 p-0">
                <div class="card">
                  <div class="card-body">
                    <p class="m-0">Liste der Übersichte</p>
                    <div class="row all-reports mt-5">
                      <div class="col-md-2 p-0">
                        <ul class="nav nav-tabs card p-0 mb-0" id="reports" role="tablist">
                          <li class="nav-item w-100">
                            <a class="nav-link active" data-toggle="tab" href="#gap-auswertung" role="tab" aria-controls="personal-reports">{{ $t('menu.overview') }} {{ $t('menu.gap_analysis') }}</a>
                          </li>
                          <li class="nav-item w-100">
                            <a class="nav-link" data-toggle="tab" href="#gap-auswertung-percent" role="tab" aria-controls="personal-reports">{{ $t('menu.overview') }} {{ $t('menu.gap_analysis') }} {{ $t('with_percentage') }}</a>
                          </li>
                          <li class="nav-item w-100">
                            <a class="nav-link" data-toggle="tab" href="#task-auswertung" role="tab" aria-controls="shared-reports">{{ $t('menu.overview') }} {{ $t('task') }}</a>
                          </li>
                          <li class="nav-item w-100">
                            <a class="nav-link" data-toggle="tab" href="#task-auswertung-percent" role="tab" aria-controls="shared-reports">{{ $t('menu.overview') }} {{ $t('task') }} {{ $t('with_percentage') }}</a>
                          </li>
                        </ul>
                      </div>
                      <div class="col-md-10 pr-0 Reports">
                        <div class="tab-content pt-0">
                          <div class="tab-pane active" id="gap-auswertung" role="tabpanel">
                            <div class="card" style="width: 100%;">
                              <div class="row">
                                <div class="col-xl-8">
                                  <canvas id="ds-auswertung-graphic" v-show="dsAuswertungLoaded"></canvas>
                                </div>
                                <div class="col-xl-4 table-responsive">
                                  <table class="table mb-0">
                                    <thead>
                                    <tr>
                                      <th>{{ $t('topics') }}</th>
                                      <th>{{ $t('finished') }}</th>
                                      <th>{{ $t('in_progress') }}</th>
                                      <th>{{ $t('no_entry') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="data in dsAuswertungLoadedData">
                                      <td>{{ data[0] }}</td>
                                      <td>{{ data[1] }}</td>
                                      <td>{{ data[2] }}</td>
                                      <td>{{ data[3] }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <FingerPrintSpinner v-show="!dsAuswertungLoaded" color="#9b3136" />
                            </div>
                          </div>
                          <div class="tab-pane" id="gap-auswertung-percent" role="tabpanel">
                            <div class="card" style="width: 100%;">
                              <div class="row">
                                <div class="col-xl-8">
                                  <canvas id="ds-gap-auswertung-percent" v-show="dsAuswertungPercentLoaded"></canvas>
                                </div>
                                <div class="col-xl-4 table-responsive">
                                  <table class="table mb-0">
                                    <thead>
                                    <tr>
                                      <th>{{ $t('topics') }}</th>
                                      <th>{{ $t('finished') }}</th>
                                      <th>{{ $t('in_progress') }}</th>
                                      <th>{{ $t('no_entry') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="data in dsAuswertungPercentLoadedData">
                                      <td>{{ data[0] }}</td>
                                      <td>{{ data[1] }}%</td>
                                      <td>{{ data[2] }}%</td>
                                      <td>{{ data[3] }}%</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <FingerPrintSpinner v-show="!dsAuswertungPercentLoaded" color="#9b3136" />
                            </div>
                          </div>
                          <div class="tab-pane" id="task-auswertung" role="tabpanel">
                            <div class="row">
                            <div class="card col-lg-8" style="width: 100%; flex: inherit">
                              <div>
                                <canvas id="task-auswertung-graphic" v-show="taskAuswertungLoaded"></canvas>
                              </div>
                              <div class="table-responsive" v-show="taskAuswertungLoaded">
                                <table class="table mb-0">
                                  <thead>
                                  <tr>
                                    <th>{{ $t('topics') }}</th>
                                    <th>{{ $t('task_status.completed') }}</th>
                                    <th>{{ $t('task_status.in_progress') }}</th>
                                    <th>{{ $t('task_status.open') }}</th>
                                    <th>{{ $t('task_status.other') }}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="data in taskAuswertungLoadedData">
                                    <td>{{ data[0] }}</td>
                                    <td>{{ data[1] }}</td>
                                    <td>{{ data[2] }}</td>
                                    <td>{{ data[3] }}</td>
                                    <td>{{ data[4] }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                              <FingerPrintSpinner v-show="!taskAuswertungLoaded" color="#9b3136" />
                            </div>
                            <div class="card col-lg-2 ml-2">
                              <div class="card-header">
                                <h5 class="card-title mb-0">{{ $t('task_in_the_year') }}</h5>
                              </div>
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" :class="{active: year === activeYear}" v-for="year in taskYears"><a href="#" class="nav-link" :ref="'taskYear'+year" @click.prevent="updateTaskChart(year)">{{ year }}</a></li>
                              </ul>
                            </div>
                            </div>
                          </div>
                          <div class="tab-pane" id="task-auswertung-percent" role="tabpanel">
                            <div class="row">
                            <div class="card col-lg-8" style="width: 1024px; flex: inherit">
                              <div>
                                <canvas id="task-auswertung-percent-graphic" v-show="taskAuswertungPercentLoaded"></canvas>
                              </div>
                              <div class="table-responsive" v-show="taskAuswertungPercentLoaded">
                                <table class="table mb-0">
                                  <thead>
                                  <tr>
                                    <th>{{ $t('topics') }}</th>
                                    <th>{{ $t('task_status.completed') }}</th>
                                    <th>{{ $t('task_status.in_progress') }}</th>
                                    <th>{{ $t('task_status.open') }}</th>
                                    <th>{{ $t('task_status.other') }}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="data in taskAuswertungPercentLoadedData">
                                    <td>{{ data[0] }}</td>
                                    <td>{{ data[1] }}%</td>
                                    <td>{{ data[2] }}%</td>
                                    <td>{{ data[3] }}%</td>
                                    <td>{{ data[4] }}%</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                              <FingerPrintSpinner v-show="!taskAuswertungPercentLoaded" color="#9b3136" />
                            </div>
                            <div class="card col-lg-2 ml-2">
                              <div class="card-header">
                                <h5 class="card-title mb-0">{{ $t('task_in_the_year') }}</h5>
                              </div>
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" :class="{active: year === activePercentYear}" v-for="year in taskPercentYears"><a href="#" class="nav-link" :ref="'taskYear'+year" @click.prevent="updateTaskPercentChart(year)">{{ year }}</a></li>
                              </ul>
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
					</div>
					<!-- /Content End -->

                </div>
				<!-- /Page Content -->

            </div>
			<!-- /Page Wrapper -->
        </diV>
    </div>
</template>
<script>
  import FingerPrintSpinner from '@/components/component/FingerPrintSpinner.vue'
  import service from '@/utils/request.js'
  import {mapState} from "vuex";

  export default {
    components: { FingerPrintSpinner },
    data() {
      return {
        dsChart: null,
        dsPercentChart: null,
        taskChart: null,
        taskPercentChart: null,
        dsAuswertungLoaded: false,
        dsAuswertungLoadedData: [],
        dsAuswertungPercentLoaded: false,
        dsAuswertungPercentLoadedData: [],
        taskAuswertungLoaded: false,
        taskAuswertungLoadedData: [],
        taskAuswertungPercentLoaded: false,
        taskAuswertungPercentLoadedData: [],
        taskYears: [],
        taskPercentYears: [],
        activeYear: 0,
        activePercentYear: 0,
      }
    },
    computed: {...mapState({accountid: state => state.account.accountid})},
		async mounted() {
      this.loadDSMSChart();
      this.loadTaskChart();
		},
    methods: {
      loadDSMSChart() {
        try {
          service.request({
            url: `todos/v1/get_dsms_level/?customer_id=${this.accountid}`,
            method: 'GET',
            responseType: 'json'
          }).then(response => {
            if (!this.dsChart) {
              this.dsChart = new Chart(
                document.getElementById('ds-auswertung-graphic'),
                {
                  type: 'bar',
                  plugins: [ChartDataLabels],
                  data: {
                    labels: response.data.labels,
                    datasets: [{
                      label: 'Erledigt',
                      data: response.data.closed,
                      fill: true,
                      backgroundColor: '#92be0550',
                      borderColor: 'rgb(13, 255, 20)',
                      pointBackgroundColor: 'rgb(13, 255, 20)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(13, 255, 20)'
                    }, {
                      label: 'In Bearbeitung',
                      data: response.data.processing,
                      fill: true,
                      backgroundColor: '#FF990080',
                      borderColor: 'rgb(255,165,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,255,0)'
                    }, {
                      label: this.$t('no_entry'),
                      data: response.data.open,
                      fill: true,
                      backgroundColor: '#9b3136cc',
                      borderColor: 'rgb(255,0,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,0,0)'
                    }]
                  },
                  options: {
                    plugins: {
                      title: {
                        display: true,
                        text: 'Auswertung Gap Analyse'
                      },
                      datalabels: {
                        color: '#1f1f1f',
                        formatter: function(value, context) {
                          return value === 0 ? '' : value
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true
                      }
                    }
                  }
                })
              response.data.labels.forEach((label, index) => {
                this.dsAuswertungLoadedData.push([label, response.data.closed[index], response.data.processing[index], response.data.open[index]])
              })
              this.dsAuswertungLoaded = true
            }
            if (!this.dsPercentChart) {
              let closedPercentage = []
              let processingPercentage = []
              let openPercentage = []
              response.data.labels.forEach((label, index) => {
                closedPercentage.push(Math.round((response.data.closed[index] / response.data.total[index]) * 100))
                processingPercentage.push(Math.round((response.data.processing[index] / response.data.total[index]) * 100))
                openPercentage.push(Math.round((response.data.open[index] / response.data.total[index]) * 100))
              })
              this.dsPercentChart = new Chart(
                document.getElementById('ds-gap-auswertung-percent'),
                {
                  type: 'bar',
                  plugins: [ChartDataLabels],
                  data: {
                    labels: response.data.labels,
                    datasets: [{
                      label: 'Erledigt',
                      data: closedPercentage,
                      fill: true,
                      backgroundColor: '#92be0550',
                      borderColor: 'rgb(13, 255, 20)',
                      pointBackgroundColor: 'rgb(13, 255, 20)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(13, 255, 20)'
                    }, {
                      label: 'In Bearbeitung',
                      data: processingPercentage,
                      fill: true,
                      backgroundColor: '#FF990080',
                      borderColor: 'rgb(255,165,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,255,0)'
                    }, {
                      label: this.$t('no_entry'),
                      data: openPercentage,
                      fill: true,
                      backgroundColor: '#9b3136cc',
                      borderColor: 'rgb(255,0,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,0,0)'
                    }]
                  },
                  options: {
                    plugins: {
                      title: {
                        display: true,
                        text: 'Auswertung Gap Analyse mit Prozentangaben'
                      },
                      tooltip: {
                        callbacks: {
                          label: function(context) {
                            return `${context.dataset.label}: ${context.formattedValue}%`;
                          }
                        }
                      },
                      datalabels: {
                        color: '#1f1f1f',
                        formatter: function(value, context) {
                          return value === 0 ? '' : value + '%'
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true,
                        max: 100,
                        ticks: {
                          callback: function(value, index, values) {
                            return value === 0 ? 0 : value + '%';
                          },
                          stepSize: 25
                        }
                      }
                    }
                  }
                })
              response.data.labels.forEach((label, index) => {
                this.dsAuswertungPercentLoadedData.push([label, closedPercentage[index], processingPercentage[index], openPercentage[index]])
              })
              this.dsAuswertungPercentLoaded = true
            }
          }).catch(e => {
            this.dsAuswertungLoaded = true
            this.dsAuswertungPercentLoaded = true
            console.error(e)
          })
        } catch (e) {
          console.error(e)
        }
      },
      updateTaskChart(year) {
        service.request({
          url: `todos/v1/get_task_level/?customer_id=${this.accountid}&year=${year}`,
          method: 'GET',
          responseType: 'json'
        }).then(response =>{
          this.activeYear = year
          this.taskChart.data.labels = response.data.labels
          this.taskChart.data.datasets = [{
            label: 'Abgeschlossen',
            data: response.data.closed,
            fill: true,
            hidden: true,
            backgroundColor: '#92be0580',
            borderColor: 'rgb(13, 255, 20)',
            pointBackgroundColor: 'rgb(13, 255, 20)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(13, 255, 20)'
          }, {
            label: 'In Bearbeitung',
            data: response.data.processing,
            fill: true,
            backgroundColor: '#FF990080',
            borderColor: 'rgb(255,165,0)',
            pointBackgroundColor: 'rgb(255,255,0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,255,0)'
          }, {
            label: 'Offen',
            data: response.data.open,
            fill: true,
            backgroundColor: '#9b3136cc',
            borderColor: 'rgb(255,0,0)',
            pointBackgroundColor: 'rgb(255,255,0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,0,0)'
          }, {
            label: 'Anderes',
            data: response.data.others,
            fill: true,
            backgroundColor: '#7f7e8580',
            borderColor: 'rgb(200,165,0)',
            pointBackgroundColor: 'rgb(66,60,45)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,165,0)'
          }]
          this.taskChart.update()
          this.taskAuswertungLoadedData = []
          response.data.labels.forEach((label, index) => {
            this.taskAuswertungLoadedData.push([label, response.data.closed[index], response.data.processing[index], response.data.open[index], response.data.others[index]])
          })
        })
      },
      updateTaskPercentChart(year) {
        service.request({
          url: `todos/v1/get_task_level/?customer_id=${this.accountid}&year=${year}`,
          method: 'GET',
          responseType: 'json'
        }).then(response =>{
          let closedPercentage = []
          let processingPercentage = []
          let openPercentage = []
          let othersPercentage = []
          response.data.labels.forEach((label, index) => {
            closedPercentage.push(Math.round((response.data.closed[index] / response.data.total[index]) * 100))
            processingPercentage.push(Math.round((response.data.processing[index] / response.data.total[index]) * 100))
            openPercentage.push(Math.round((response.data.open[index] / response.data.total[index]) * 100))
            othersPercentage.push(Math.round((response.data.others[index] / response.data.total[index]) * 100))
          })
          this.activePercentYear = year
          this.taskPercentChart.data.labels = response.data.labels
          this.taskPercentChart.data.datasets = [{
            label: 'Abgeschlossen',
            data: closedPercentage,
            fill: true,
            hidden: true,
            backgroundColor: '#92be0580',
            borderColor: 'rgb(13, 255, 20)',
            pointBackgroundColor: 'rgb(13, 255, 20)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(13, 255, 20)'
          }, {
            label: 'In Bearbeitung',
            data: processingPercentage,
            fill: true,
            backgroundColor: '#FF990080',
            borderColor: 'rgb(255,165,0)',
            pointBackgroundColor: 'rgb(255,255,0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,255,0)'
          }, {
            label: 'Offen',
            data: openPercentage,
            fill: true,
            backgroundColor: '#9b3136cc',
            borderColor: 'rgb(255,0,0)',
            pointBackgroundColor: 'rgb(255,255,0)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,0,0)'
          }, {
            label: 'Anderes',
            data: othersPercentage,
            fill: true,
            backgroundColor: '#7f7e8580',
            borderColor: 'rgb(200,165,0)',
            pointBackgroundColor: 'rgb(66,60,45)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255,165,0)'
          }]
          this.taskPercentChart.update()
          this.taskAuswertungPercentLoadedData = []
          response.data.labels.forEach((label, index) => {
            this.taskAuswertungPercentLoadedData.push([label, closedPercentage[index], processingPercentage[index], openPercentage[index], othersPercentage[index]])
          })
        })
      },
      handleLegendHover(evt, item, legend) {
        legend.chart.data.datasets.forEach((obj, index, dataset) => {
          dataset[index].backgroundColor = item.datasetIndex === index ? obj.backgroundColor.slice(0, -2) : obj.backgroundColor
        });
        legend.chart.update();
      },
      handleLegendLeave(evt, item, legend) {
        legend.chart.data.datasets.forEach((obj, index, dataset) => {
          dataset[index].backgroundColor = item.datasetIndex === index ? obj.backgroundColor + '80' : obj.backgroundColor
        });
        legend.chart.update();
      },
      loadTaskChart() {
        try {
          service.request({
            url: `todos/v1/get_task_level/?customer_id=${this.accountid}`,
            method: 'GET',
            responseType: 'json'
          }).then(response => {
            if (!this.taskChart) {
              this.taskChart = new Chart(
                document.getElementById('task-auswertung-graphic'),
                {
                  type: 'bar',
                  plugins: [ChartDataLabels],
                  data: {
                    labels: response.data.labels,
                    datasets: [{
                      label: 'Abgeschlossen',
                      data: response.data.closed,
                      fill: true,
                      hidden: true,
                      backgroundColor: '#92be0580',
                      borderColor: 'rgb(13, 255, 20)',
                      pointBackgroundColor: 'rgb(13, 255, 20)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(13, 255, 20)'
                    }, {
                      label: 'In Bearbeitung',
                      data: response.data.processing,
                      fill: true,
                      backgroundColor: '#FF990080',
                      borderColor: 'rgb(255,165,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,255,0)'
                    }, {
                      label: 'Offen',
                      data: response.data.open,
                      fill: true,
                      backgroundColor: '#9b3136cc',
                      borderColor: 'rgb(255,0,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,0,0)'
                    }, {
                      label: 'Anderes',
                      data: response.data.others,
                      fill: true,
                      backgroundColor: '#7f7e8580',
                      borderColor: 'rgb(200,165,0)',
                      pointBackgroundColor: 'rgb(66,60,45)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,165,0)'
                    }]
                  },
                  options: {
                    plugins: {
                      legend: {
                        onHover: this.handleLegendHover,
                        onLeave: this.handleLegendLeave
                      },
                      title: {
                        display: true,
                        text: 'Auswertung Maßnahmenplan'
                      },
                      datalabels: {
                        color: '#1f1f1f',
                        formatter: function(value, context) {
                          return value === 0 ? '' : value
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true,
                        ticks: {
                          stepSize: 1
                        }
                      }
                    }
                  }
                })
              response.data.labels.forEach((label, index) => {
                this.taskAuswertungLoadedData.push([label, response.data.closed[index], response.data.processing[index], response.data.open[index], response.data.others[index]])
              })
              this.taskAuswertungLoaded = true
            }
            if (!this.taskPercentChart) {
              let closedPercentage = []
              let processingPercentage = []
              let openPercentage = []
              let othersPercentage = []
              response.data.labels.forEach((label, index) => {
                closedPercentage.push(Math.round((response.data.closed[index] / response.data.total[index]) * 100))
                processingPercentage.push(Math.round((response.data.processing[index] / response.data.total[index]) * 100))
                openPercentage.push(Math.round((response.data.open[index] / response.data.total[index]) * 100))
                othersPercentage.push(Math.round((response.data.others[index] / response.data.total[index]) * 100))
              })
              this.taskPercentChart = new Chart(
                document.getElementById('task-auswertung-percent-graphic'),
                {
                  type: 'bar',
                  plugins: [ChartDataLabels],
                  data: {
                    labels: response.data.labels,
                    datasets: [{
                      label: 'Abgeschlossen',
                      data: closedPercentage,
                      hidden: true,
                      fill: true,
                      backgroundColor: '#92be0580',
                      borderColor: 'rgb(13, 255, 20)',
                      pointBackgroundColor: 'rgb(13, 255, 20)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(13, 255, 20)'
                    }, {
                      label: 'In Bearbeitung',
                      data: processingPercentage,
                      fill: true,
                      backgroundColor: '#FF990080',
                      borderColor: 'rgb(255,165,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,255,0)'
                    }, {
                      label: 'Offen',
                      data: openPercentage,
                      fill: true,
                      backgroundColor: '#9b3136cc',
                      borderColor: 'rgb(255,0,0)',
                      pointBackgroundColor: 'rgb(255,255,0)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,0,0)'
                    }, {
                      label: 'Anderes',
                      data: othersPercentage,
                      fill: true,
                      backgroundColor: '#7f7e8580',
                      borderColor: 'rgb(200,165,0)',
                      pointBackgroundColor: 'rgb(66,60,45)',
                      pointBorderColor: '#fff',
                      pointHoverBackgroundColor: '#fff',
                      pointHoverBorderColor: 'rgb(255,165,0)'
                    }]
                  },
                  options: {
                    plugins: {
                      legend: {
                        onHover: this.handleLegendHover,
                        onLeave: this.handleLegendLeave
                      },
                      title: {
                        display: true,
                        text: 'Auswertung Maßnahmenplan'
                      },
                      tooltip: {
                        callbacks: {
                          label: function(context) {
                            return `${context.dataset.label}: ${context.formattedValue}%`;
                          }
                        }
                      },
                      datalabels: {
                        color: '#1f1f1f',
                        formatter: function(value, context) {
                          return value === 0 ? '' : value + '%'
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true,
                        max: 100,
                        ticks: {
                          callback: function(value, index, values) {
                            return value === 0 ? 0 : value + '%';
                          },
                          stepSize: 25
                        }
                      }
                    }
                  }
                })
              response.data.labels.forEach((label, index) => {
                this.taskAuswertungPercentLoadedData.push([label, closedPercentage[index], processingPercentage[index], openPercentage[index], othersPercentage[index]])
              })
              this.taskAuswertungPercentLoaded = true
            }
            this.taskYears = response.data.taskYears
            this.taskPercentYears = response.data.taskYears
          }).catch(e => {
            this.taskAuswertungLoaded = true
            this.taskAuswertungPercentLoaded = true
            console.error(e)
          })
        } catch (e) {
          console.error(e)
        }
      },
    }
	}
</script>
<style scoped>
.list-group-item.active {
  background-color: #f6f6f6;
  border-color: #f6f6f6;
}
</style>
